import {Pipe, PipeTransform} from '@angular/core';
import {Contract} from "../../model/contract";

@Pipe({
  name: 'sortByProductName',
  standalone: true,
})
export class SortByProductNamePipe implements PipeTransform {
  transform(value: Contract[]): Contract[] {
    if (!value) {
      return value;
    }
    value.sort(this.sort);
    return value;
  }

  sort(a: Contract, b: Contract): number {
    let avalue = a.product.name.toLowerCase();
    let bvalue = b.product.name.toLowerCase();
    if (avalue === bvalue) {
      return 0;
    }
    return avalue > bvalue && 1 || -1;
  }
}
